export const ISSUED_ITEMS_FILE_ACTIVITY_CONTAINER_TAG_NAME = 'issued-items-file-activity-container';
